import React, { FC, ReactNode } from "react";
import classNames from "classnames";
import {UseFormRegister, UseFormTrigger} from "react-hook-form";

import { SvgIcon } from "../../../SvgIcon/SvgIcon";
import {InlineMessage} from "../InlineMessage/InlineMessage";

export type CheckBoxProps = {
  label: ReactNode;
  name: string;
  error?: any;
  register: UseFormRegister<any>;
  required?: boolean;
  onClick?: () => void;
  backgroundColor?: string;
  disabled?: boolean;
  trigger: UseFormTrigger<any>;
};

export const CheckBox: FC<CheckBoxProps> = ({
  label,
  name,
  register,
  error,
  required = false,
  children,
  onClick,
  disabled,
  trigger  
}) => {
  const id = `input-${name}`;
  
  return (
    <div className={classNames(
        "CheckBox", 
        { "CheckBox--error": !!error},
        { "CheckBox--disabled": disabled}
    )}>
      <div className="CheckBox__inputWrapper">
        <input
          {...register(name,
              {
                onChange: () => {
                  // Manually trigger a validation for this specific field
                  // Solution inspired by https://github.com/react-hook-form/react-hook-form/issues/10863
                  trigger(name);
                }
              }
          )}
          type="checkbox"
          id={id}
          name={name}
          className="CheckBox__input"
          required={required}
          aria-describedby={`errorId-${id} helpId-${id}`}
          onClick={onClick}
          disabled={disabled}
        />
        <SvgIcon iconName="checkmark" className="CheckBox__checkIcon" />
      </div>
      <div>
        <label htmlFor={id} className="CheckBox__label">
          {label}
        </label>

        {error?.message && (
            <InlineMessage variant="error" msg={error && error.message} id={`errorId-${id}`} className="CheckBox__msg" />
        )}

        {children && (
            <InlineMessage variant="info" id={`helpId-${id}`} msg={children} className="CheckBox__msg CheckBox__msg--help" hideIcon/>
        )}
      </div>
    </div>
  );
};
